import { FC, useEffect, useRef, useState } from 'react';
import { get_active_ads, loadImageFromUrl } from '../../../modules/communication';
import styled from 'styled-components';
import defaultImage from '../../../static/assets/restore_mini_logo.png';

const Container = styled.div(({ theme }) => {
  const { color } = theme;
  return `
    padding: 0.75rem;
    background-color: ${color.grayscale[0]}30;
    width: 100%;
    height: 100%;
  `;
});

const Image = styled.img`
  width: inherit;
  height: inherit;
  object-fit: cover;
`;

const Communication: FC = () => {
  const [imageIndex, setImageIndex] = useState(0);
  const [imageUrl, setImageUrl] = useState('');
  const [communications, setCommunications] = useState([]);
  const intervalRef = useRef<number>();

  useEffect(() => {
    get_active_ads()
      .then((response) => {
        response && setCommunications(response.data.communications);
      })
      .catch((error) => {
        throw new Error(`Error loading communication image ${error}`);
      });
  }, []);

  useEffect(() => {
    if (communications.length > 1) {
      intervalRef.current = window.setInterval(() => {
        setImageIndex((imageIndex + 1) % communications.length);
      }, 30000);

      return () => {
        clearInterval(intervalRef.current);
      };
    }
  });

  useEffect(() => {
    if (communications.length) {
      const imageName = communications[imageIndex];

      loadImageFromUrl(imageName)
        .then((response) => {
          response && setImageUrl(response.imageData);
        })
        .catch((error) => {
          throw new Error(`Error loading communication image ${error}`);
        });
    } else {
      setImageUrl(defaultImage);
    }
  }, [communications, imageIndex]);

  return <Container>{imageUrl !== '' && <Image className="communication" src={imageUrl} alt="" />}</Container>;
};

export default Communication;
